/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPartialYesNoEnum } from './CRSFPartialYesNoEnum';
import {
    CRSFPartialYesNoEnumFromJSON,
    CRSFPartialYesNoEnumFromJSONTyped,
    CRSFPartialYesNoEnumToJSON,
} from './CRSFPartialYesNoEnum';

/**
 * 
 * @export
 * @interface CRSFPrivacyPolicyAnalysisExternalResult
 */
export interface CRSFPrivacyPolicyAnalysisExternalResult {
    /**
     * 
     * @type {CRSFPartialYesNoEnum}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    advanced_privacy_controls?: CRSFPartialYesNoEnum;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    contact_address?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    last_updated?: string;
    /**
     * 
     * @type {CRSFPartialYesNoEnum}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    mention_of_childrens_data?: CRSFPartialYesNoEnum;
    /**
     * 
     * @type {CRSFPartialYesNoEnum}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    mention_of_generic_tracking_technologies?: CRSFPartialYesNoEnum;
    /**
     * 
     * @type {CRSFPartialYesNoEnum}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    mention_of_opt_out?: CRSFPartialYesNoEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyPolicyAnalysisExternalResult
     */
    specific_tracking_technologies?: Array<string>;
}

/**
 * Check if a given object implements the CRSFPrivacyPolicyAnalysisExternalResult interface.
 */
export function instanceOfCRSFPrivacyPolicyAnalysisExternalResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFPrivacyPolicyAnalysisExternalResultFromJSON(json: any): CRSFPrivacyPolicyAnalysisExternalResult {
    return CRSFPrivacyPolicyAnalysisExternalResultFromJSONTyped(json, false);
}

export function CRSFPrivacyPolicyAnalysisExternalResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyPolicyAnalysisExternalResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advanced_privacy_controls': !exists(json, 'advanced_privacy_controls') ? undefined : CRSFPartialYesNoEnumFromJSON(json['advanced_privacy_controls']),
        'contact_address': !exists(json, 'contact_address') ? undefined : json['contact_address'],
        'contact_email': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'contact_phone': !exists(json, 'contact_phone') ? undefined : json['contact_phone'],
        'last_updated': !exists(json, 'last_updated') ? undefined : json['last_updated'],
        'mention_of_childrens_data': !exists(json, 'mention_of_childrens_data') ? undefined : CRSFPartialYesNoEnumFromJSON(json['mention_of_childrens_data']),
        'mention_of_generic_tracking_technologies': !exists(json, 'mention_of_generic_tracking_technologies') ? undefined : CRSFPartialYesNoEnumFromJSON(json['mention_of_generic_tracking_technologies']),
        'mention_of_opt_out': !exists(json, 'mention_of_opt_out') ? undefined : CRSFPartialYesNoEnumFromJSON(json['mention_of_opt_out']),
        'specific_tracking_technologies': !exists(json, 'specific_tracking_technologies') ? undefined : json['specific_tracking_technologies'],
    };
}

export function CRSFPrivacyPolicyAnalysisExternalResultToJSON(value?: CRSFPrivacyPolicyAnalysisExternalResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advanced_privacy_controls': CRSFPartialYesNoEnumToJSON(value.advanced_privacy_controls),
        'contact_address': value.contact_address,
        'contact_email': value.contact_email,
        'contact_phone': value.contact_phone,
        'last_updated': value.last_updated,
        'mention_of_childrens_data': CRSFPartialYesNoEnumToJSON(value.mention_of_childrens_data),
        'mention_of_generic_tracking_technologies': CRSFPartialYesNoEnumToJSON(value.mention_of_generic_tracking_technologies),
        'mention_of_opt_out': CRSFPartialYesNoEnumToJSON(value.mention_of_opt_out),
        'specific_tracking_technologies': value.specific_tracking_technologies,
    };
}

